import {Language} from "../../util/enum";
import {MentionKey, MentionType} from "./templateEditor";

export const EditorEmptyRawState: string = JSON.stringify({"blocks": [{"key": "80fl5", "text": "", "type": "unstyled", "depth": 0, "inlineStyleRanges": [], "entityRanges": [], "data": {}}], "entityMap": {}})

export const AppointmentReminderDefaultState = (language: Language) => {
    let text = "";
    let entityRanges: Array<any> = [];
    switch (language) {
    case Language.english:
        text = "Hi #Patient Name, Please confirm your upcoming appointment on #Appointment Time with #Provider Name #Appointment Confirmation Link. If you would like to cancel or reschedule, please contact us at #Office Phone Number."
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 62, "length": 17, "key": 1},
            {"offset": 85, "length": 14, "key": 2},
            {"offset": 100, "length": 30, "key": 3},
            {"offset": 196, "length": 20, "key": 4},
        ]
        break
    case Language.simplifiedChinese:
        text = "您好 #Patient Name，您于 #Appointment Time 与 #Provider Name 有一个问诊预约。请点击链接 #Appointment Confirmation Link 确认。如需改期或取消，请致电 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 69, "length": 30, "key": 3},
            {"offset": 115, "length": 20, "key": 4},
        ]
        break
    case Language.traditionalChinese:
        text = "您好 #Patient Name，您於 #Appointment Time 與 #Provider Name 有一个問診預約。請點擊鏈接 #Appointment Confirmation Link 確認。如需改期或取消，請致電 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 69, "length": 30, "key": 3},
            {"offset": 115, "length": 20, "key": 4},
        ]
        break
    case Language.korean:
        text = "안녕하세요 #Patient Name. #Appointment Time 에 #Provider Name 과 약속이 있습니다. #Appointment Confirmation Link 링크를 클릭하여 확인하십시오. 약속을 변경하거나 취소하려면 #Office Phone Number 로 전화하십시오."
        entityRanges = [
            {"offset": 6, "length": 13, "key": 0},
            {"offset": 21, "length": 17, "key": 1},
            {"offset": 41, "length": 14, "key": 2},
            {"offset": 68, "length": 30, "key": 3},
            {"offset": 132, "length": 20, "key": 4},
        ]
        break
    default:
        return ""
    }
    return JSON.stringify({
        "blocks": [
            {
                "key": "6hg17",
                "text": text,
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": entityRanges,
                "data": {},
            },
        ],
        "entityMap": {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Patient Name", "link": MentionKey.patientName, "type": MentionType.name}}},
            "1": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Appointment Time", "link": MentionKey.appointmentTime, "type": MentionType.date}}},
            "2": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Provider Name", "link": MentionKey.providerName, "type": MentionType.name}}},
            "3": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Appointment Confirmation Link", "link": MentionKey.appointmentConfirmationLink, "type": MentionType.link}}},
            "4": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Office Phone Number", "link": MentionKey.officePhone, "type": MentionType.phone}}},
        },
    })
}
export const AppointmentReminderSecondState = (language: Language) => {
    let text = "";
    let entityRanges: Array<any> = [];
    switch (language) {
    case Language.english:
        text = "Hi #Patient Name, you will have an appointment on #Appointment Time with #Provider Name. If you haven’t confirmed, please confirm at #Appointment Confirmation Link. If you would like to cancel or reschedule, please contact us at #Office Phone Number."
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 50, "length": 17, "key": 1},
            {"offset": 73, "length": 14, "key": 2},
            {"offset": 133, "length": 30, "key": 3},
            {"offset": 229, "length": 20, "key": 4},
        ]
        break
    case Language.simplifiedChinese:
        text = "您好 #Patient Name，您于 #Appointment Time 与 #Provider Name 有一个问诊预约。如果您还未确认的话，请点击链接 #Appointment Confirmation Link 确认。如需改期或取消，请致电 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 79, "length": 30, "key": 3},
            {"offset": 125, "length": 20, "key": 4},
        ]
        break
    case Language.traditionalChinese:
        text = "您好 #Patient Name，您於 #Appointment Time 與 #Provider Name 有一個問診預約。如果您還未確認的話，請點擊鏈接 #Appointment Confirmation Link 確認。如需改期或取消，請致電 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 79, "length": 30, "key": 3},
            {"offset": 125, "length": 20, "key": 4},
        ]
        break
    case Language.korean:
        text = "#Patient Name 님, 안녕하세요. #Appointment Time 에 #Provider Name 님과 약속이 있습니다. 아직 확인하지 않으셨다면 #Appointment Confirmation Link 링크를 클릭하여 확인하세요. 일정을 변경하거나 취소하려면 #Office Phone Number 로 전화하세요."
        entityRanges = [
            {"offset": 0, "length": 13, "key": 0},
            {"offset": 24, "length": 17, "key": 1},
            {"offset": 44, "length": 14, "key": 2},
            {"offset": 86, "length": 30, "key": 3},
            {"offset": 149, "length": 20, "key": 4},
        ]
        break
    default:
        return ""
    }
    return JSON.stringify({
        "blocks": [
            {
                "key": "6hg17",
                "text": text,
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": entityRanges,
                "data": {},
            },
        ],
        "entityMap": {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Patient Name", "link": MentionKey.patientName, "type": MentionType.name}}},
            "1": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Appointment Time", "link": MentionKey.appointmentTime, "type": MentionType.date}}},
            "2": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Provider Name", "link": MentionKey.providerName, "type": MentionType.name}}},
            "3": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Appointment Confirmation Link", "link": MentionKey.appointmentConfirmationLink, "type": MentionType.link}}},
            "4": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Office Phone Number", "link": MentionKey.officePhone, "type": MentionType.phone}}},
        },
    })
}
export const AppointmentReminderThirdState = (language: Language) => {
    let text = "";
    let entityRanges: Array<any> = [];
    switch (language) {
    case Language.english:
        text = "Hi #Patient Name, you will have an appointment on #Appointment Time with #Provider Name. If you would like to cancel or reschedule, please contact us at #Office Phone Number."
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 50, "length": 17, "key": 1},
            {"offset": 73, "length": 14, "key": 2},
            {"offset": 153, "length": 20, "key": 3},
        ]
        break
    case Language.simplifiedChinese:
        text = "您好 #Patient Name，您于 #Appointment Time 与 #Provider Name 有一个问诊预约。如需改期或取消，请致电 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 75, "length": 20, "key": 3},
        ]
        break
    case Language.traditionalChinese:
        text = "您好 #Patient Name，您於 #Appointment Time 與 #Provider Name 有一個問診預約。如需改期或取消，請致電 #Office Phone Number。"
        entityRanges = [
            {"offset": 3, "length": 13, "key": 0},
            {"offset": 20, "length": 17, "key": 1},
            {"offset": 40, "length": 14, "key": 2},
            {"offset": 75, "length": 20, "key": 3},
        ]
        break
    case Language.korean:
        text = "#Patient Name 님, 안녕하세요. #Appointment Time 에 #Provider Name 님과 약속이 있습니다. 취소하거나 일정을 변경하려면 #Office Phone Number 로 문의하십시오."
        entityRanges = [
            {"offset": 0, "length": 13, "key": 0},
            {"offset": 24, "length": 17, "key": 1},
            {"offset": 44, "length": 14, "key": 2},
            {"offset": 88, "length": 20, "key": 3},
        ]
        break
    default:
        return ""
    }
    return JSON.stringify({
        "blocks": [
            {
                "key": "6hg17",
                "text": text,
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": entityRanges,
                "data": {},
            },
        ],
        "entityMap": {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Patient Name", "link": MentionKey.patientName, "type": MentionType.name}}},
            "1": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Appointment Time", "link": MentionKey.appointmentTime, "type": MentionType.date}}},
            "2": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Provider Name", "link": MentionKey.providerName, "type": MentionType.name}}},
            "3": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Office Phone Number", "link": MentionKey.officePhone, "type": MentionType.phone}}},
        },
    })
}
export const BirthdayDefaultState = (language: Language) => {
    let text = "";
    let entityRanges: Array<any> = [];
    let entityMap: object = {};
    switch (language) {
    case Language.english:
        text = "Happy birthday #Patient First Name ! Our team at #Practice Name wishes you another year filled with happiness, good health and success!"
        entityRanges = [
            {"offset": 15, "length": 19, "key": 0},
            {"offset": 49, "length": 14, "key": 1},
        ]
        entityMap = {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Patient First Name", "link": MentionKey.patientFirstName, "type": MentionType.name}}},
            "1": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Practice Name", "link": MentionKey.practiceName, "type": MentionType.name}}},
        }
        break
    case Language.simplifiedChinese:
        text = "#Practice Name 祝您生日快乐！身体健康！"
        entityRanges = [{"offset": 0, "length": 14, "key": 0}]
        entityMap = {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Practice Name", "link": MentionKey.practiceName, "type": MentionType.name}}},
        }
        break
    case Language.traditionalChinese:
        text = "#Practice Name 祝您生日快樂！身體健康！"
        entityRanges = [{"offset": 0, "length": 14, "key": 0}]
        entityMap = {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Practice Name", "link": MentionKey.practiceName, "type": MentionType.name}}},
        }
        break
    case Language.korean:
        text = "생일 축하합니다 #Patient First Name ! 우리 #Practice Name 팀은 행복, 건강, 성공이 가득한 한 해를 기원합니다!"
        entityRanges = [
            {"offset": 9, "length": 19, "key": 0},
            {"offset": 34, "length": 14, "key": 1},
        ]
        entityMap = {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Patient First Name", "link": MentionKey.patientFirstName, "type": MentionType.name}}},
            "1": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "Practice Name", "link": MentionKey.practiceName, "type": MentionType.name}}},
        }
        break
    default:
        return ""
    }
    return JSON.stringify({
        "blocks": [
            {
                "key": "53bvt",
                "text": text,
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": entityRanges,
                "data": {},
            },
        ],
        "entityMap": entityMap,
    })
}

export const AppInstallationDefaultState = (language: Language) => {
    let text = "";
    let entityRanges: Array<any> = [];
    switch (language) {
    case Language.english:
        text = "Download iClinicHealth at #iClinicHealth App Download Link."
        entityRanges = [{"offset": 26, "length": 32, "key": 0}]
        break
    case Language.simplifiedChinese:
        text = "点击链接 #iClinicHealth App Download Link 下载iClinicHealth。"
        entityRanges = [{"offset": 5, "length": 32, "key": 0}]
        break
    case Language.traditionalChinese:
        text = "點擊鏈接 #iClinicHealth App Download Link 下载iClinicHealth。"
        entityRanges = [{"offset": 5, "length": 32, "key": 0}]
        break
    default:
        return ""
    }
    return JSON.stringify({
        "blocks": [
            {
                "key": "53bvt",
                "text": text,
                "type": "unstyled",
                "depth": 0,
                "inlineStyleRanges": [],
                "entityRanges": entityRanges,
                "data": {},
            },
        ],
        "entityMap": {
            "0": {"type": "#mention", "mutability": "IMMUTABLE", "data": {"mention": {"name": "iClinicHealth App Download Link", "link": MentionKey.appDownloadLink, "type": MentionType.link}}},
        },
    })
}
